import type {DirectoryNode} from 'src/typings';
import type {UrlStateManagerService} from 'shared/state-manager';
import type {IMvStateService, MediaViewerFile, MediaViewerState} from '../lib/mv-types';
import type {Observable} from 'rxjs';
import {firstValueFrom} from 'rxjs';

export class MvUrlStateService implements IMvStateService {
    public static serviceName = 'mediaViewerUrlManagementService';

    /*@ngInject*/
    constructor(private urlStateManagerService: UrlStateManagerService<MediaViewerState>) {
    }

    public async getCurrentUrlState(): Promise<MediaViewerState> {
        const urlState$ = this.urlStateManagerService.getState$();
        return firstValueFrom(urlState$);
    }

    public getUrlState$(): Observable<MediaViewerState> {
        return this.urlStateManagerService.getState$();
    }

    public setSelectedDirectory(value: DirectoryNode) {
        this.urlStateManagerService.requestChangeStateParameter('directory', value.id.toString());
    }

    public setViewedFile(value: MediaViewerFile | null) {
        this.urlStateManagerService.requestChangeStateParameter('file', value?.id?.toString() ?? null);
    }

    public setSearchQuery(value: string | null) {
        this.urlStateManagerService.requestChangeStateParameter('q', value);
    }

    public setPageNumber(value: number | null) {
        this.urlStateManagerService.requestChangeStateParameter('page', value?.toString());
    }

    public resetToDefault(): void {
        this.setPageNumber(null);
    }
}